"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundByCurrency = exports.MathFunctionMap = exports.RoundingType = void 0;
exports.RoundingType = {
    up: 'up',
    down: 'down',
    off: 'off',
    '': '',
};
exports.MathFunctionMap = {
    up: Math.ceil,
    down: Math.floor,
    off: Math.round,
    '': Math.round, // 使用 off 和 digits 1
};
function round(value, type = 'off', digits = 1) {
    if (value == null)
        return 0;
    value = Number(value);
    if (type === exports.RoundingType[''] && digits === 0) {
        digits = 1;
    }
    if (type === exports.RoundingType['']) {
        type = exports.RoundingType.off;
    }
    if (value < 0) {
        const roundedNegativeValue = round(Math.abs(value), type, digits);
        return -roundedNegativeValue;
    }
    const mathFunction = exports.MathFunctionMap[type];
    const digitsAdjust = Math.pow(10, digits);
    const roundedValue = mathFunction(value * digitsAdjust) / digitsAdjust;
    return roundedValue;
}
exports.default = round;
function roundByCurrency(order, value) {
    if (order.currency === 'THB') {
        return round(value, 'off', 2);
    }
    if (order.currency === 'HKD') {
        return round(value, 'off', 1);
    }
    if (order.currency === 'TWD') {
        return round(value, 'off', 0);
    }
    return value;
}
exports.roundByCurrency = roundByCurrency;
//# sourceMappingURL=round.js.map